import { render } from "./VipStatusView.vue?vue&type=template&id=79184fa1&scoped=true"
import script from "./VipStatusView.vue?vue&type=script&lang=js"
export * from "./VipStatusView.vue?vue&type=script&lang=js"

import "./VipStatusView.vue?vue&type=style&index=0&id=79184fa1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79184fa1"]])

export default __exports__